module.exports = __webpack_public_path__ + "static/media/Arosa_Lenzerheide_02.e4a18546.png";